import { AuthModalLabelsT, SocialProviderT } from './AuthModal.types';

export const BUCKET_URL = 'https://assets.fluer.com';

export const CONSTANTS = {
  // same for now, please update if needed
  darkThemeImageSrc: `${BUCKET_URL}/assets/img/landing_page/dark_mode/auth_modal_image.webp`,
  lightThemeImageSrc: `${BUCKET_URL}/assets/img/landing_page/light_mode/auth_modal_image.webp`,
  googleUserinfoApiUrl: 'https://www.googleapis.com/oauth2/v1/userinfo?access_token=',
  form: {
    emailFieldName: 'email',
    passwordFieldName: 'password',
    codeFieldName: 'code',
    marketingFieldName: 'marketing_communications',
    firstNameFieldName: 'first_name',
  },
  errors: {
    e500: 'We are very sorry, but due to a technical error we are unable to complete your request. Please try again later or contact us at support@fluer.com.',
  },
  googleClientId: '202326758210-shcv7tn3grojsg71h7i4cnb32tsh9gmv.apps.googleusercontent.com',
};

export const AUTH_MODAL_LABELS: AuthModalLabelsT = {
  loading: {
    loadingMessage: 'Authorizing...',
  },
  login: {
    // LOGIN EMAIL
    emailView: {
      title: 'Welcome back!',
      subtitle: 'Use your email or another service to continue with Fluer for Free.',
      form: {
        placeholder: 'Email',
      },
      cta: {
        anotherWay: 'Continue another way',
        continueWith: 'Continue with',
        continue: 'Continue',
      },
      or: 'or',
      disclaimer: {
        text: `By continuing, you agree to Fluer's`,
        tosLinkText: 'Terms of Service',
        ppLinkText: 'Privacy Policy',
        and: 'and',
      },
      errors: {
        client: {
          required: 'Please input your email.',
          email: 'Please input a valid email address.',
        },
        e500: CONSTANTS.errors.e500,
      },
    },

    // LOGIN PASSWORD
    passwordView: {
      title: 'Finish logging in',
      subtitle: 'Use your password to log in.',

      form: {
        placeholder: 'Password',
      },
      errors: {
        client: {
          required: 'Please input your password.',
        },
        e401: 'Incorrect password.',
        e500: CONSTANTS.errors.e500,
      },
      cta: {
        continue: 'Log in',
        resetPassword: 'Reset',
        continueWith: 'Continue with',
        anotherWay: 'Continue another way',
      },
      or: 'or',
      forgotPassword: 'Forgot your password?',
      getResetPasswordSuccessMessage: (email: string) =>
        `We have sent you an email to ${email} with instructions on how to reset your password. Please double check if the provided email is correct.`,
    },

    anotherWay: {
      continueWith: 'Continue with',
      disclaimer: {
        text: `By continuing, you agree to Fluer's`,
        tosLinkText: 'Terms of Service',
        ppLinkText: 'Privacy Policy',
        and: 'and',
      },
      title: 'Continue another way',
    },
  },
  signup: {
    // SIGNUP EMAIL
    emailView: {
      title: 'Get started in seconds!',
      subtitle: 'Use your email or another service to continue with Fluer for Free.',
      form: {
        placeholder: 'Email',
      },
      cta: {
        anotherWay: 'Continue another way',
        continueWith: 'Continue with',
        continue: 'Continue',
      },
      or: 'or',
      disclaimer: {
        text: `By continuing, you agree to Fluer's`,
        tosLinkText: 'Terms of Service',
        ppLinkText: 'Privacy Policy',
        and: 'and',
      },
      errors: {
        client: {
          required: 'Please input your email.',
          email: 'Please input a valid email address.',
        },
        e500: CONSTANTS.errors.e500,
      },
    },

    // SIGNUP CODE
    codeView: {
      title: 'Sign up code',
      cta: {
        continue: 'Continue',
        resend: 'Resend code',
      },
      form: {
        placeholder: 'Enter Code',
      },
      didntGetCode: 'Did not get the code?',
      getSubtitle: (email: string) =>
        `Check your email. We have sent you a temporary code to ${email} to continue signing up.`,

      errors: {
        client: {
          required: 'Please input the code.',
        },
        incorrectCode: 'The code you entered is incorrect.',
        e500: CONSTANTS.errors.e500,
      },
    },

    passwordView: {
      title: 'Welcome to Fluer',
      subtitle: 'Create a password which is hard to guess:',
      form: {
        newPasswordLabel: 'Set a password',
        newPasswordPlaceholder: 'Password',
        marketingLabel: 'I agree to Fluer sending marketing communications about Fluer to me.',
      },
      cta: {
        continue: 'Continue',
      },
      errors: {
        client: {
          newPasswordMinLenght: 'Password must be at least 8 characters long.',
          newPasswordRequired: 'Please input your password.',
        },
        e500: CONSTANTS.errors.e500,
      },
    },

    nameView: {
      title: 'Welcome to Fluer',
      subtitle: 'Tell us a bit about yourself.',
      form: {
        label: 'Your name',
        placeholder: 'Enter Name',
      },
      cta: {
        continue: 'Create your account',
      },
      errors: {
        e500: CONSTANTS.errors.e500,
      },
    },
  },
};

export const getSocialProviders = (handleGoogleLogin?: () => any): SocialProviderT[] => {
  return [
    {
      id: 'sp-google',
      icon: 'brand-google',
      name: 'Google',
      onClick: () => {
        handleGoogleLogin?.();
      },
    },
    {
      id: 'sp-facebook',
      icon: 'brand-facebook',
      name: 'Facebook',
      onClick: () => {
        console.log('onClick Facebook Provider');
      },
    },
  ];
};
